import React, { useEffect } from 'react';
import './Location.css';
import './Home.css';

function TermsAndConditions() {
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on page load
    }, []);

    return (
        <div className='location-main'>
            <div className='container-fluid'>
                <div className="container py-5">
                    <h1 className="text-center syne-title mb-4">
                        Terms & Conditions<span className='text-rose'>.</span>
                    </h1>

                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <p className='text-secondary'>
                                Welcome to Tattva Reality & Infra. These Terms & Conditions govern your access to and use of our website and services. By accessing or using our services, you agree to comply with these terms.
                            </p>

                            <h4 className='syne-title py-3'>Scope of Services</h4>
                            <p className='text-secondary'>
                                Tattva Reality & Infra offers comprehensive real estate solutions, including property consultancy, development, market analysis, and construction management. Our services are committed to supporting your real estate needs professionally and efficiently.
                            </p>

                            <h4 className='syne-title py-3'>User Obligations</h4>
                            <p className='text-secondary'>
                                As a user of Tattva Reality & Infra's services, you agree to:
                                <ul className='list-unstyled'>
                                    <li className='my-2'><i className="fas fa-check-double text-rose me-2"></i>Use our services only for lawful and legitimate purposes.</li>
                                    <li className='my-2'><i className="fas fa-check-double text-rose me-2"></i>Provide truthful, accurate, and up-to-date information when required.</li>
                                    <li className='my-2'><i className="fas fa-check-double text-rose me-2"></i>Respect the rights of others and avoid unauthorized use of our platform.</li>
                                </ul>
                            </p>

                            <h4 className='syne-title py-3'>Limitation of Liability</h4>
                            <p className='text-secondary'>
                                While we endeavor to maintain the accuracy of our content, Tattva Reality & Infra makes no guarantees regarding the completeness or reliability of the information provided. We disclaim liability for any loss or damages arising from your use of our services.
                            </p>

                            <h4 className='syne-title py-3'>Intellectual Property Rights</h4>
                            <p className='text-secondary'>
                                All materials available on this website, including text, images, logos, and graphics, are the exclusive property of Tattva Reality & Infra. Unauthorized reproduction or use of these materials is strictly prohibited.
                            </p>

                            <h4 className='syne-title py-3'>Termination of Services</h4>
                            <p className='text-secondary'>
                                Tattva Reality & Infra reserves the right to suspend or terminate your access to our services if any violation of these terms is detected.
                            </p>

                            <h4 className='syne-title py-3'>Modifications to Terms</h4>
                            <p className='text-secondary'>
                                We may revise these Terms & Conditions periodically to accommodate changes in our services or comply with legal requirements. Continued use of our services after such revisions constitutes your acceptance of the updated terms.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Home Discuss */}
            <div className='container-fluid py-5 home-discuss'>
                <div className='container py-5 home-discuss-inner bg-light p-4 rounded-15 shadow-sm'>
                    <h1 className='syne-title mb-4 text-start'>
                        LET'S DISCUSS<br />YOUR IDEA<span className='text-rose'>.</span>
                    </h1>
                    <div className='discuss-inner'>
                        <div className='row align-items-center'>
                            <div className='col-lg-6'>
                                <div className='discuss-left text-start'>
                                    <p className='text-secondary'>
                                        We’re excited to hear your vision! Whether you have a concept or need assistance with brainstorming, our expert team is ready to collaborate. Connect with us and let’s turn your real estate ideas into reality—schedule a meeting today!
                                    </p>
                                    <div className='discuss-mail d-flex align-items-center my-3'>
                                        <i className='fas fa-envelope me-2'></i>
                                        <p className='mb-0 text-secondary'>contact@tattvarealityinfra.com</p>
                                    </div>
                                    <div className='discuss-mail d-flex align-items-center my-3'>
                                        <i className='fas fa-mobile-alt me-2'></i>
                                        <p className='mb-0 text-secondary'>+91 88970 35800</p>
                                    </div>
                                    <div className='discuss-mail d-flex align-items-center my-3'>
                                        <i className='fas fa-map-marker-alt me-2'></i>
                                        <p className='mb-0 text-secondary'>10, Prashanthi Hills, Khajaguda, Gachibowli, Hyderabad</p>
                                    </div>
                                    <div className='discuss-icons d-flex'>
                                        <a href='https://www.linkedin.com/company/tattva-reality-infra/' target='_blank' rel="noreferrer" className='text-decoration-none'>
                                            <i className='fab fa-linkedin-in text-white'></i>
                                        </a>
                                        <a href='https://twitter.com/tattvareality' target='_blank' rel="noreferrer" className='text-decoration-none'>
                                            <i className='fab fa-twitter text-white'></i>
                                        </a>
                                        <a href='https://www.facebook.com/tattvarealityinfra' target='_blank' rel="noreferrer" className='text-decoration-none'>
                                            <i className='fab fa-facebook-f text-white'></i>
                                        </a>
                                        <a href='https://www.instagram.com/tattvarealityinfra/' target='_blank' rel="noreferrer" className='text-decoration-none'>
                                            <i className='fab fa-instagram text-white'></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className='col-lg-6'>
                                <form action="https://api.web3forms.com/submit" method="POST">
                                    <input type="hidden" name="access_key" value="d567d7ce-8cc7-4fdd-a9ae-66c9c3461e68" />
                                    <input
                                        type='text'
                                        placeholder='Name'
                                        name="name"
                                        className='form-control my-2'
                                        required
                                    />
                                    <input
                                        type='text'
                                        placeholder='Mobile'
                                        name="mobile"
                                        className='form-control my-2'
                                        required
                                    />
                                    <input
                                        type='email'
                                        placeholder='Email'
                                        name="email"
                                        className='form-control my-2'
                                        required
                                    />
                                    <textarea
                                        placeholder='Message'
                                        name="message"
                                        rows='4'
                                        className='form-control my-2'
                                        required
                                    />
                                    <div className='text-start mt-3 d-flex align-items-center'>
                                        <span className='fs-2 text-rose'>→</span>
                                        <input type='submit' value='Send' className='border-0 text-rose discuss-btn' />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Home Discuss */}
        </div>
    );
}

export default TermsAndConditions;
